<template>
  <div>
    <div class="flex items-center pl-2.5">
      <span class="material-icons-outlined mr-1 filter-icon">filter_list</span>
      <p class="filter-text">{{ $t("OrderPage[\"Filters by Category:\"]") }}</p>
    </div>
    <div class="mt-2 flex flex-wrap items-center">
      <el-tag
        v-for="tag in nonEmptyDiscountPanelFilterTags"
        :key="tag.index"
        effect="plain"
        :class="[
          'm-1 cursor-pointer',
          tag.isSelect ? 'select-filter-tag' : 'unselect-filter-tag'
        ]"
        @click="handleClickTag(tag)"
      >
        <div class="flex items-center">
          <span v-if="tag.isSelect" class="material-icons-outlined check-icon mr-2.5">
            check
          </span>
          <p>{{ getTagNameByLanguage(tag.names) }}</p>
        </div>
      </el-tag>
      <el-button class="clear-all-filter-btn" @click="clearAllFilters">
        {{ $t("OrderPage[\"Clear All\"]") }}
      </el-button>
    </div>
  </div>
</template>

<script>
import { LANGUAGE_MAP } from '@/utils/const';
import { mapState } from 'vuex';

export default {
  props: {
    clearAllFiltersTrigger: {
      type: Number,
      default: 0
    },
  },
  computed: {
    ...mapState(["language"]),
    ...mapState("orderTest", ["isDbsVersion", "dbsMap"]),
    ...mapState("orderTest/panels", [
      "discountPanelList", 
      "serumDiscountPanelList", 
      "dbsDiscountPanelList",
      "discountPanelFilterTagList"
    ]),
    // return discount panel "filters by category" tags which has bundles under it only
    nonEmptyDiscountPanelFilterTags() {
      if (!this.isDbsVersion) {
        return this.discountPanelFilterTagList;
      }
      let nonEmptyTags = [];
      let discountPanelList = this.isDbsVersion
        ? this.dbsDiscountPanelList
        : this.serumDiscountPanelList;
      this.discountPanelFilterTagList.forEach(tag => {
        // find any dbs bundles
        let dbsBundleIds = this.dbsMap
          .filter(map => tag.bundleIdList.includes(map.originalItemId))
          .map(m => m.dbsItemId);
        let dbsBundles = discountPanelList.filter(bundle => dbsBundleIds.includes(bundle.bundleId));
        if (dbsBundles.length > 0) { // there are bundles under current tag
          nonEmptyTags.push(tag);
        }
        else {
          let foundBundles = discountPanelList.filter(bundle => tag.bundleIdList.includes(bundle.bundleId));
          if (foundBundles.length > 0) {
            nonEmptyTags.push(tag);
          }
        }
      })
      return nonEmptyTags;
    },
  },

  watch: {
    clearAllFiltersTrigger() {
      this.clearAllFilters();
    },

    isDbsVersion() {
      this.clearAllFilters();
    }
  },

  methods: {
    // select/de-select filter tag in discount panel
    handleClickTag(tag) {
      tag.isSelect = !tag.isSelect;
      let selectedTagList = this.discountPanelFilterTagList
        .filter((tag) => tag.isSelect);
      this.$emit("clickTag", selectedTagList);
    },

    // clear all selected filter tags in discount panel
    clearAllFilters() {
      this.discountPanelFilterTagList.forEach((tag) => (tag.isSelect = false));
      this.$emit("clearAllFilters");
    },

    getTagNameByLanguage(names) {
      let language = LANGUAGE_MAP[this.language];
      return names[language] || names.english;
    }
    
  }
}
</script>

<style scoped>
.filter-icon {
  font-size: 18px;
}

.filter-text {
  font-weight: 600;
  font-size: 12px;
  line-height: 20px;
  letter-spacing: 0.1px;
}

.unselect-filter-tag {
  border: 1px solid #d8d8d8;
  border-radius: 31px;
  font-weight: 500;
  font-size: 12px;
  letter-spacing: 0.1px;
  color: #767676;
}

.select-filter-tag {
  background: #f9fbfd;
  border: 1px solid #3498db;
  box-sizing: border-box;
  border-radius: 31px;
  font-family: "Roboto";
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  letter-spacing: 0.1px;
  color: #3498db;
}

.check-icon {
  font-size: 14px;
}
.clear-all-filter-btn {
  border: none;
  padding-bottom: 6px;
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
  letter-spacing: 0.1px;
  color: #20a8c3;
}

.clear-all-filter-btn:hover {
  color: #20a8c3;
  background-color: transparent;
}
</style>